import React, { Component } from 'react'
import Upload from '@common/Upload'
import ImgGallery from '@common/ImgGallery'
import { CloseOutlined } from '@ant-design/icons'
import style from './style.module.less'

class UploadCom extends Component {
  uploadImg = (file, link) => {
    const { onChange } = this.props
    let { value } = this.props
    value.push({
      kind: file.type.indexOf('image') >= 0 ? '1' : '2',
      path: link,
      name: file.name
    })
    onChange && onChange(value)
  }

  onRemove = (index, item) => {
    const { onChange } = this.props
    let { value } = this.props
    const idx = value.findIndex(it => it.path === item.path)
    value.splice(idx, 1)
    onChange && onChange(value)
  }
  render() {
    let { value, showUpload = true } = this.props
    value = value || []
    const imgArr = value.filter(item => item.kind == 1)
    const ohterArr = value.filter(item => item.kind != 1)
    return (
      <div className={style['upload-wrap']}>
        {showUpload ? (
          <Upload
            onOk={this.uploadImg}
            uptoken_url="file_upload_token"
            filters={{
              mime_types: [
                {
                  title: 'all files',
                  extensions: '*'
                }
              ],
              max_file_size: '1024mb',
              prevent_duplicates: true
            }}
          >
            +添加附件
          </Upload>
        ) : null}
        <ImgGallery
          keyField="path"
          imgList={imgArr}
          showUpload={false}
          onRemove={this.onRemove}
          showRemove={showUpload}
        />
        {ohterArr.map((item, index) => {
          return (
            <a
              className={style['other-item']}
              href={`${item.path}?attname=${encodeURI(item.name)}`}
              target="__blank"
              key={index}
            >
              {item.name}
              {showUpload ? (
                <CloseOutlined
                  onClick={e => {
                    e.stopPropagation()
                    e.preventDefault()
                    this.onRemove(index, item)
                  }}
                />
              ) : null}
            </a>
          )
        })}
      </div>
    )
  }
}

export default UploadCom
